import React from "react";
import type { InterfaceLanguageCode } from "src/app/consts/AvailableLanguages";

export const LocalizedAppContext = React.createContext<{
  languageCode: InterfaceLanguageCode;
  setLanguageCode: (languageCode: InterfaceLanguageCode) => void;
}>({
  languageCode: "en",
  setLanguageCode: () => {},
});
